import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * `/projects/:slug/work-items/new/:type` — legacy entry point.
 * Forwards to the global `/work-items/new/:type` form with the
 * project pre-selected; the global form is the single ported
 * work-item create surface.
 */
export const Route = createFileRoute("/_app/projects/$slug/work-items/new/$type")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/work-items/new/$type",
      params: { type: params.type },
      search: { project: params.slug },
    });
  },
});
